/**
 * Quantity Tier Sync for Shopify
 * Syncs tier selection buttons with quantity input
 */

(function() {
  'use strict';
  
  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  function init() {
    // Find tier buttons and quantity input
    const tierButtons = document.querySelectorAll('[data-quantity-tier]');
    const quantityInput = document.querySelector('input[name="quantity"]');
    
    if (!tierButtons.length || !quantityInput) {
      console.log('Tier buttons or quantity input not found');
      return;
    }
    
    console.log(`Found ${tierButtons.length} tier buttons`);
    
    // Tier configuration - adjust these based on your app settings
    const tiers = [
      { min: 1, max: 24, button: null },
      { min: 25, max: 49, button: null },
      { min: 50, max: 99, button: null },
      { min: 100, max: Infinity, button: null }
    ];
    
    // Map buttons to tiers
    tierButtons.forEach((button, index) => {
      if (tiers[index]) {
        tiers[index].button = button;
      }
    });
    
    // Function to get tier for a quantity
    function getTierForQuantity(qty) {
      return tiers.find(tier => qty >= tier.min && qty <= tier.max);
    }
    
    // Function to select tier
    function selectTier(tier) {
      if (!tier || !tier.button) return;
      
      // Remove active class from all buttons
      tierButtons.forEach(btn => btn.classList.remove('active', 'selected'));
      
      // Add active class to selected button
      tier.button.classList.add('active', 'selected');
    }
    
    // When tier button is clicked
    tierButtons.forEach((button, index) => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        
        const tier = tiers[index];
        if (!tier) return;
        
        // Set quantity to minimum of tier
        quantityInput.value = tier.min;
        
        // Set max attribute (optional - remove if you don't want limits)
        if (tier.max !== Infinity) {
          quantityInput.setAttribute('max', tier.max);
        } else {
          quantityInput.removeAttribute('max');
        }
        
        // Trigger change event
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
        
        // Select this tier
        selectTier(tier);
        
        console.log(`Tier selected: ${tier.min}-${tier.max === Infinity ? '+' : tier.max}, Quantity set to: ${tier.min}`);
      });
    });
    
    // When quantity input changes manually
    quantityInput.addEventListener('input', function() {
      const qty = parseInt(this.value) || 1;
      
      // Enforce max if set
      const max = parseInt(this.getAttribute('max'));
      if (max && qty > max) {
        this.value = max;
        return;
      }
      
      // Auto-select correct tier
      const tier = getTierForQuantity(qty);
      if (tier) {
        selectTier(tier);
        console.log(`Quantity changed to ${qty}, auto-selected tier: ${tier.min}-${tier.max === Infinity ? '+' : tier.max}`);
      }
    });
    
    // Initialize: select tier based on current quantity
    const initialQty = parseInt(quantityInput.value) || 1;
    const initialTier = getTierForQuantity(initialQty);
    if (initialTier) {
      selectTier(initialTier);
    }
  }
})();